import React, { Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setFileTemplateType, setPage } from '../Actions/Library.action';
import LibraryDocuments from './LibraryDocuments';
import LibraryDownload from './LibraryDownload';
import LibraryPhotos from './LibraryPhotos';

const tabs = [
  { name: 'documents', fileTemplateType: 1, view: <LibraryDocuments /> },
  { name: 'photo', fileTemplateType: 2, view: <LibraryPhotos /> },
];

const Library = () => {
  const dispatch = useDispatch();
  const { fileTemplateType } = useSelector((state) => state.library);
  return (
    <Fragment>
      {tabs.map((tab, index) => (
        <input
          key={index}
          type="radio"
          className="tab__radio"
          id={`library-${tab.name}`}
          name="tab-radio"
          checked={fileTemplateType === tab.fileTemplateType}
          onClick={() => {
            dispatch(setPage(1));
            dispatch(setFileTemplateType(tab.fileTemplateType));
          }}
        />
      ))}
      <div className="tab-mobile-container">
        <nav className="tab__header-container">
          {tabs.map((tab, index) => (
            <label
              key={index}
              className="tab__header library__tab-name"
              htmlFor={`library-${tab.name}`}
            >
              {tab.name}
            </label>
          ))}
        </nav>
      </div>
      <section className="tab__content-container">
        <div className="row ">
          <div className="columns large-12">
            {tabs.map((tab, index) => (
              <div
                key={index}
                className="tab__content tab__content--small-padding library__tab-content"
              >
                <LibraryDownload />
                {tab.view}
              </div>
            ))}
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default Library;
